import React, { useState, useEffect } from 'react';
import { SelectSurface, SurfaceOption } from '../property-selectors/surface-selection';
import { MapToolsStore } from '@openlayers/MapToolsStore';
import { Measurement, CalcSurface } from '../../../../../../typings/reality-capture/volumes/models';

export const SurfaceEditor = ({
    kind,
    toolsStore,
    measurement,
    onChange,
}: {
    kind: 'reference' | 'target';
    toolsStore: MapToolsStore;
    measurement: Measurement;
    onChange: (surface: CalcSurface) => void;
}) => {
    const initial = kind === 'reference' ? measurement.calcReference : measurement.calcTarget;
    const [selected, setSelected] = useState<CalcSurface | null>(initial);
    const [option, setOption] = useState<SurfaceOption>(initial?.surfaceType || '');
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        const nextInitial = kind === 'reference' ? measurement.calcReference : measurement.calcTarget;
        setSelected(nextInitial);
        setOption(nextInitial?.surfaceType || '');
        setIsEditing(false);
    }, [kind, measurement, measurement.calcReference, measurement.calcTarget]);

    const cancelEdit = () => {
        setSelected(initial);
        setOption(initial?.surfaceType || '');
        setIsEditing(false);
    };

    const saveEdit = () => {
        console.log('saveEdit', selected);
        if (selected) {
            setOption(selected.surfaceType);
            onChange(selected);
        }
        setIsEditing(false);
    };

    const clearSelection = () => {
        setSelected(null);
        setOption('');
    };

    const text = kind === 'reference' ? measurement.calcReference?.text : measurement.calcTarget?.text;
    const editTooltip = kind === 'reference' ? __('js_map_measuring_tools.edit_reference') : __('js_map_measuring_tools.edit_target');

    if (isEditing) {
        return (
            <div className="flex items-center gap-2 flex-wrap">
                <div className="flex items-center gap-1 shrink-0">
                    <i
                        className="iki iki-check cursor-pointer text-green-600 hover:text-green-700"
                        onClick={saveEdit}
                        title={__('general.save')}
                    />
                    <i
                        className="iki iki-cross cursor-pointer text-ik-text-weak hover:text-ik-text-strong"
                        onClick={cancelEdit}
                        title={__('general.cancel')}
                    />
                </div>
                <SelectSurface
                    toolsStore={toolsStore}
                    selection={selected}
                    onSelect={setSelected}
                    onClear={clearSelection}
                />
            </div>
        );
    }

    return (
        <div className="flex items-center gap-2 min-w-0">
            <i
                className="iki iki-edit cursor-pointer text-ik-text-weak hover:text-ik-text-strong shrink-0"
                onClick={() => setIsEditing(true)}
                title={editTooltip}
            />
            <span className="text-sm text-ik-text-default truncate min-w-0" title={text}>{text}</span>
        </div>
    );
};
